// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__mnoIF","icon":"Skill_icon__PtNw2","technologyName":"Skill_technologyName__9MDl+"};